<template>
	<div class="asin-trends-main" v-loading="config.loading">
		<div >
			<el-card class="box-card" shadow="hover" v-if="searchData.asinInfo" :body-style="{ padding : '10px 20px'}">
				<div class="asin-info-box">
					<div class="left">
						<el-image :src="searchData.asinInfo.imgs[0]" :preview-src-list="searchData.asinInfo.imgs" v-if="searchData.asinInfo.imgs"
							style="width: 55px;height: 50px"></el-image>
					</div>
					<div class="middle">
						<div class="title overflow-one-line">{{ searchData.asinInfo.title }}</div>
						<div class="desc overflow-one-line">
							<span>
								<span>{{ searchData.search.asin }} </span>
								<copy-sub :value="searchData.search.asin"></copy-sub>
								<el-tooltip effect="light" placement="top" :content="'在亚马逊中打开'">
									<a target="_blank"
										:href="'https://www.'+ getCountryObjByCity(searchData.search.country).department +'/dp/' + searchData.search.asin + '?&_encoding=UTF8&tag=yuzone00-20&linkCode=ur2&linkId=9dc4a4f9e26ed16b3d10606d082063f2&camp=1789&creative=9325'"
										style="margin-left: 5px;">
										<i class="fa fa-plane" aria-hidden="true"></i>
									</a>
								</el-tooltip>
							</span>
							<span>
								<span class="value">
									<el-rate v-model="searchData.asinInfo.score"
										disabled show-score text-color="#ff9900"
										class="el-rate-20221216" score-template="{value}"></el-rate>
									<span style="color: #ff9900;"> ({{searchData.asinInfo.commentNum || 0 }})</span>
								</span>
							</span>
							<span>
								<span class="emphasis-hint">{{ searchData.asinInfo.price }}</span>
							</span>

							<span v-if="searchData.asinInfo.brand">
								<span class="key">品牌: </span>
								<span class="value">{{ searchData.asinInfo.brand }}</span>
							</span>
							<span v-if="searchData.asinInfo.seller">
								<span class="key">卖家: </span>
								<span class="value">{{ searchData.asinInfo.seller }}</span>
								<span v-if="searchData.asinInfo.distributionMode" class="value">
									({{ searchData.asinInfo.distributionMode }})
								</span>
							</span>
						</div>
					</div>
					<!-- <div class="right">
						<div class="asin-statistic">
							<div>
								<el-tooltip :content="'历史关键词总数'">
									<el-tag class="btn">{{ searchData.keywordsTotal }}</el-tag>
								</el-tooltip>
							</div>
						</div>
					</div> -->
				</div>
			</el-card>
		</div>

		<el-dialog title="提示" :visible.sync="infoSearch.visible" width="1200px">

		</el-dialog>
	</div>
</template>

<script>
import { COUNTRY_CODE_MAP, getCountryObjByCity } from "@/components/config/countryCodeConfig";
import COPY_SUB from "@/components/template/otherSub/copySub";
import { api_asin_batchAsinInfoQuery_public } from "@/components/api/asinBasiceInfo";

export default {
	name: 'simpleASINTrends',
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'LOGINUSER', 'F_LOGIN'],
	data() {
		return {
			windowObj: this.WINDOW,
			loginUser: this.LOGINUSER,
			config : {
				loading :false,
				tableLoading : false,
				url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
				activeName : '1', //1 趋势图表 2 表格
			},
			search : {
				country : COUNTRY_CODE_MAP[0].value,
				asin : null,
			},
			searchData : {
				search : {},
			},infoSearch : {
				visible : false,
				date : null
			}
		};
	},
	props : {
		asin : {
			// required : true,
			default:  'B07S1897SM'
		},
		country : {
			default : COUNTRY_CODE_MAP[0].value
		}
	},
	components : {
		'copy-sub': COPY_SUB
	},
	created() {
		this.$data.search.asin = this.asin
		this.$data.search.country = this.country
		this.$options.methods.loadData(this)
	},
	methods: {
		loadData : function(this_) {
			this_ = this_ || this
			let parameter = {...this_.$data.search}

			this_.$data.searchData.search = parameter
			this_.$data.config.loading = true
			api_asin_batchAsinInfoQuery_public([parameter.asin], parameter.country).then(res => {
				let data = res.data
				this_.$data.searchData.asinInfo = data[0]
				this_.$data.config.loading = false
			}).catch(err => {
				this_.$data.config.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '加载失败，请重新尝试'), 4)
			})
		},
		getCountryObjByCity : function(c) {
			return getCountryObjByCity(c)
		}
	},watch : {
		// asin : {
		// 	handler() {
		// 		this.$options.methods.loadData(this)
		// 	},
		// 	deep: true
		// },
		// country: {
		// 	handler() {
		// 		this.$options.methods.loadData(this)
		// 	},
		// 	deep: true
		// },
		windowObj: {
			handler() {
			},
			deep: true
		},
		loginUser: {
			handler() {
			},
			deep: true
		}
	}
};
</script>

<style scoped>
.asin-trends-main{
	margin: 0 auto;
}
.asin-trends-main > div:not(:first-child) {
	margin-top: 10px;
}

.box-card{
	color: inherit;
}
.box-card .card-header{
	padding: 0 10px;
	font-size: 16px;
	font-weight: bold;
	line-height: 28px;
	border-left: 4px solid #409EFF;
}
/*头部ASIN信息*/
.asin-info-box{
	display: flex;
	line-height: 25px;
}
.asin-info-box .left{
	margin-right: 15px;
	border: 1px solid #E4E7ED;
	border-radius: 4px;
	padding: 5px;
}
.asin-info-box .middle{
	flex: 1;
	overflow: hidden;
}
.asin-info-box .middle .title{
	font-size: 16px;
}
.asin-info-box .desc{
	margin-top: 5px;
	font-size: 14px;
}
.asin-info-box .desc .key{

}
.asin-info-box .desc > span:not(:first-child){
	margin-left: 20px;
}
.asin-info-box .middle .review-num{
	vertical-align: middle;
}
.asin-info-box .right{
	width: 150px;
	display: flex;
	justify-content: flex-end;
	flex-wrap: wrap;
}
.asin-info-box .right .time-box{
	display: flex;
	justify-content: flex-end;
	align-items: center;
	flex-basis:100%;
	margin-bottom: 10px;
}
.asin-info-box .right .asin-statistic{
	display: flex;
	justify-content: flex-end;
	width: 300px;
}
.asin-info-box .right .asin-statistic > div{
	display: flex;
	flex-direction: column;
	text-align: center;
}
.asin-info-box .right .asin-statistic .btn{
	border: none;
	height: 56px;
	font-size: 14px;
	font-weight: bolder;
	line-height: 56px;
	text-align: center;
	min-width: 56px;
}

.table-1 .ratio-div {
	font-size: 13px;
	line-height: 25px;
	width: 50px;
	margin: auto;
	text-align: right;
}

.page-box{
	padding-top: 20px;
	text-align: right;
}
</style>
<style>

.el-rate-20221216 {
	font-size: 14px;
	display: inline-block;
	padding-top: 2px;
}

.el-rate-20221216 > span > i {
	margin-right: 0;
	font-size: 14px;
}

.el-rate-20221216 .el-rate__text {
	margin-left: 2px;
	font-size: 14px;
}

</style>